import type { ComponentProps } from 'vue-component-type-helpers';
import { modalStateKey } from '~/plugins/modal';

export function _useModal() {
  const modalState = inject(modalStateKey);

  return <T extends Component>(component: T, parent: any, { props }: { props?: ComponentProps<T> } = {}) => {
    if (!modalState) {
      throw new Error('modalState not initialized');
    }

    const id = Symbol('useModal');

    const modal = {
      id,
      component,
      props: props || {},
      hide: () => {
        const i = modalState.findIndex((modal) => modal.id === id);

        if (i !== null && i >= 0) {
          modalState.splice(i, 1);
        }
      }
    };

    modalState.push(modal);

    return modal;
  };
}

export const useModal = createSharedComposable(_useModal);
